<!-- 收银台 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="wechatPay-main">
      <div class="pay-message" v-if="!hasBuy">
        <span>订单提交成功，请尽快付款！订单号：{{orderInfo.osn}}</span>
        <span>
          应付金额：
          <span style="color: red;font-weight: bold">{{orderInfo.surplusMoney}}</span>元
        </span>
      </div>
      <el-card class="box-card hasBuy" v-if="hasBuy">{{hasBuy}}</el-card>
      <el-card class="box-card" v-else>
        <div class="wechatPay-title">
          <span>微信支付</span>
          <span>
            距离二维码过期还有
            <span class="color-red">{{countdown}}</span>
            秒,过期后请
            <span class="refresh" @click="refresh">刷新</span>
            页面重新获取二维码
          </span>
        </div>
        <div class="wechatPay-img">
          <div class="qr-code-ctn">
            <div class="invalid" v-show="isInvalid">
              <div class="invalid-text">
                <div>二维码已失效</div>
                <br />
                <el-button type="primary" @click="refresh">刷新</el-button>
              </div>
            </div>
            <div class="invalid" v-show="isSuccess">支付成功</div>
            <img :src="QRImg" alt class="qr-code" />
            <div class="qr-dir">
              <img src="../../../assets/images/scan.png" alt />
              <div>
                <p>请使用微信扫一扫</p>
                <p>扫描二维码支付</p>
              </div>
            </div>
          </div>
          <img src="../../../assets/images/example.jpg" alt />
        </div>
        <div @click="back" class="back-pay">＜ 返回选择其他支付方式</div>
      </el-card>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb
  },
  data() {
    return {
      hasBuy: false,
      isSuccess: false,
      isInvalid: false,
      countdown: 120,
      payWay: 0,
      showOrderMsg: false,
      osn: "",
      orderInfo: {},
      QRImg: ""
    };
  },
  mounted() {
    this.osn = this.$route.query.osn;
    this.getData();
    this.getQRImg();
  },
  beforeDestroy() {
    this.$socketPay.closeSocket();
  },
  methods: {
    refresh() {
      window.location.reload();
    },
    getData() {
      this.$util
        .axiosGet({
          url: "/api/Pay/GetPayPageInfo",
          data: {
            osn: this.osn
          }
        })
        .then(res => {
          let data = res.data;
          this.orderInfo = data;
          this.connectSoket(data.osn);
        });
    },
    connectSoket(osn) {
      this.$socketPay.initWebSocket(osn).then(() => {
        this.$socketPay.receiveWebsocket((payRes, type) => {
          if (type == "NoticeGetPayMsg") {
            if (payRes.paystate == 1) {
              this.hasBuy = payRes.msg;
              this.$util.warningMsg(payRes.msg);
              return;
            }
          }
          if (type == "NoticePayResult") {
            if (payRes.paystate == 0) {
              this.isSuccess = true;
              this.$util.successMsg(payRes.msg);
              this.$router.push(`./payWechatResult?osn=${this.osn}&state=0`);
            } else {
              this.$util.warningMsg(payRes.msg);
              this.$router.push(`./payWechatResult?osn=${this.osn}&state=1`);
            }
          }
        });
      });
    },
    getQRImg() {
      this.$util
        .axiosGet({
          url: "/api/Pay/WxScanCodeGen",
          data: {
            osn: this.osn,
            uid: this.$util.getLocalStorage("userMsg").EmployeeId
          },
          QRImg: true,
          exception: true
        })
        .then(response => {
          return (
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )
          );
        })
        .then(data => {
          this.QRImg = data;
          this.timer();
        });
    },
    timer() {
      let time = 120;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.isInvalid = true;
          return;
        }
        time = time - 1;
        this.countdown = time;
      }, 1000);
    },
    back() {
      this.$router.push(`./pay?osn=${this.osn}`);
    }
  }
};
</script>
<style lang="less" scoped>
.refresh {
  cursor: pointer;
  color: red;
  text-decoration: underline;
}
.qr-code-ctn {
  position: relative;
}
.invalid {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  width: 278px;
  height: 278px;
  z-index: 2;
  text-align: center;
  font-size: @font-lg;
  color: @font3Color;
}
.invalid-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.back-pay {
  cursor: pointer;
  font-size: @font-sm;
  color: @theme;
}
.qr-dir {
  margin-top: 10px;
  color: white;
  font-size: @font-xs;
  background: rgb(255, 118, 116);
  width: 278px;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 50px;
  img {
    width: 30px;
    height: 30px;
    margin-right: 20px;
  }
}
.box-card {
  padding: 20px;
}
.wechatPay-img {
  display: flex;
  justify-content: space-between;
  margin: 0 150px;
  padding: 50px 0;
  .qr-code {
    border: 1px solid @border3Color;
    width: 278px;
    height: 278px;
  }
  .example {
    width: 264px;
    height: 337px;
  }
}
.wechatPay-title {
  > span:nth-child(1) {
    display: inline-block;
    width: 150px;
    font-size: @font-md;
  }
}
.wechatPay-main {
  width: 1000px;
  margin: 0 auto;
}
.pay-message {
  padding: 10px;
  font-size: @font-sm;
  line-height: 1.5em;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
</style>
